import { Form } from 'antd';
import classNames from 'classnames';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { PAX_TYPE } from 'app/typings/core/admin/enum/paxType';
import { PRICE_DIFFERENTIATION_MODE } from 'app/typings/core/common/openingConfiguration/priceConfigurationType';

import { useValidationErrors } from '../../../hook/useValidationStore';

import { DailyPriceConfigurationTable } from './DailyPriceConfigurationTable/DailyPriceConfigurationTable';
import { PriceButtons } from './PriceButtons';

export const DailyPriceConfiguration = () => {
  const { isEditMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance();
  const { priceError } = useValidationErrors();
  const priceDifferentiationMode = Form.useWatch(
    ['openingConfiguration', 'priceConfiguration', 'priceDifferentiationMode'],
    form
  );
  const isAlwaysIncludedWithNight = Form.useWatch(
    'isAlwaysIncludedWithNight',
    form
  );

  const allowedPax = Form.useWatch(['allowedPaxTypes'], form);

  const hasAdultOnly =
    allowedPax?.length === 1 && allowedPax[0] === PAX_TYPE.ADULT;
  const hasChildOnly =
    allowedPax?.length === 1 && allowedPax[0] === PAX_TYPE.CHILD;
  const hasBothPaxTypes = !hasAdultOnly && !hasChildOnly;

  const hasDayPrice =
    priceDifferentiationMode ===
      PRICE_DIFFERENTIATION_MODE.WITH_CHILD_DAYTIME ||
    priceDifferentiationMode === PRICE_DIFFERENTIATION_MODE.WITH_DAYTIME;

  const hasAdultChildPrice =
    hasBothPaxTypes &&
    (priceDifferentiationMode ===
      PRICE_DIFFERENTIATION_MODE.WITH_CHILD_DAYTIME ||
      priceDifferentiationMode === PRICE_DIFFERENTIATION_MODE.WITH_CHILD);

  return (
    <div className="daily-price-configuration">
      <FormLineLayout>
        <div className="daily-price-configuration-wrapper">
          <DailyPriceConfigurationTable
            hasDayPrice={hasDayPrice}
            hasAdultChildPrice={hasAdultChildPrice}
          />
          {isEditMode && (
            <div
              className={classNames([
                'price-configuration-footer',
                { 'with-error': !priceError.isValid },
              ])}
            >
              {!priceError.isValid && (
                <span className="form-error-message">
                  Please fix the errors above to continue.
                  {priceError.errors.map((error, index) => (
                    <div key={index}>- {error.message}</div>
                  ))}
                </span>
              )}
              <PriceButtons
                priceDifferentiationMode={priceDifferentiationMode}
                disableNightToggle={!!isAlwaysIncludedWithNight}
              />
            </div>
          )}
        </div>
      </FormLineLayout>
    </div>
  );
};
